<script>
    import { onDestroy } from 'svelte'
    import _             from 'lodash'
    import * as api      from '../../shared/api.js'
    import Item          from '../../shared/Item.svelte'

    export let item
    export let active
    export let onUpdate
    export let onRemove

    let expanded = -1
    let mode     = ''

    function isDirty(item, copy) {
        return ! _.isEqual(item, copy)
    }

    function parseDate(str) {
        return str
        //return moment(str).format("DD/MM/YYYY HH:mm:ss")
    }
</script>

<style>
    .item .ui.label {
        width: 110px;
    }

    .item {
        margin: 1em 0;
    }

    .input.larger, .input.larger input {
        width: 500px;
    }
</style>

<Item bind:item={item} bind:active={active} edit={false} {isDirty} {onUpdate} {onRemove}>
    <span slot="header">
        <span class="name"> {item.name} </span>
        <span class="description">Versão <b>{item.version}</b> publicada em {parseDate(item.created)}</span>
    </span>
    <div slot="primary">
        <div class="item">
            <div class="ui labeled disabled big input" >
            <div class="ui label">Nome</div>
                <input  bind:value={item.name}
                        type="text"
                        autocomplete="false">
            </div>
        </div>
        <div class="item">
            <div class="ui labeled disabled big input" >
            <div class="ui label">Versão</div>
                <input  bind:value={item.version}
                        type="text"
                        autocomplete="false">
            </div>
        </div>
        <div class="item">
            <div class="ui labeled disabled big larger input" >
            <div class="ui label">Link</div>
                <input  bind:value={item.url}
                        type="text" 
                        autocomplete="false">
            </div>
        </div>
        <div class="item">
            <div class="ui labeled disabled big larger input" >
            <div class="ui label">Descrição</div>
                <input  bind:value={item.description}
                        type="text" 
                        autocomplete="false">
            </div>
        </div>

    </div>
</Item>
